import React from 'react';
import { HelpPanelContextData } from './HelpPanelTypes';

/**
 * @deprecated Legacy HOC-based context. Do not use in new code.
 * Define a new context in `/src/contexts/` following the `use*` hook pattern.
 */
// @ts-expect-error TS2345 - strict migration
const HelpPanelContext = React.createContext<HelpPanelContextData>(undefined);

/**
 * @deprecated Legacy HOC-based context. Do not use in new code.
 * Define a new context in `/src/contexts/` following the `use*` hook pattern.
 */
function withHelpPanelContext(Component: any) {
  return (props: any) => {
    return (
      <HelpPanelContext.Consumer>
        {(ctx) => <Component {...props} helpPanelContext={ctx} />}
      </HelpPanelContext.Consumer>
    );
  };
}

export { HelpPanelContext, withHelpPanelContext };
